"use client";

import React from "react";
import { motion } from "framer-motion";

const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 60,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
} as const;

interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  initial?: string;
  animate?: string;
  whileInView?: string;
  viewport?: any;
}

export default function AboutPageAnimated({ 
  children, 
  className = "", 
  id,
  initial = "hidden",
  animate,
  whileInView,
  viewport = { once: true, amount: 0.3 }
}: AnimatedSectionProps) {
  return (
    <motion.section
      className={className}
      id={id}
      initial={initial}
      animate={animate}
      whileInView={whileInView}
      viewport={viewport}
      variants={sectionVariants}
    >
      {children}
    </motion.section>
  );
}
